import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static get targets () {
		return ['checkbox'];
	}

	static get values () {
		return {
			id: String,
			checked: Boolean,
		};
	}

	change() {
		this.applyChecked(this.checkboxTarget.checked);
		this.emit();
		this.syncPeers();
	}

	applyChecked(checked) {
		this.checkedValue = checked;

		if (this.hasCheckboxTarget) {
			this.checkboxTarget.checked = checked;
		}

		this.element.dataset.checked = checked ? 'true' : 'false';
		this.element.classList.toggle('is-checked', checked);
	}

	emit() {
		this.element.dispatchEvent(new CustomEvent('plan-toggle:change', {
			bubbles: true,
			detail: {
				checked: this.checkedValue,
				toggleId: this.idValue,
			},
		}));
	}

	syncPeers() {
		document.querySelectorAll(`[data-plan-toggle-id-value="${this.idValue}"]`).forEach((el) => {
			if (el === this.element) {
				return;
			}

			const peer = this.application.getControllerForElementAndIdentifier(el, 'plan-toggle');
			if (peer) {
				peer.applyChecked(this.checkedValue);
			}
		});
	}

	connect() {
		this.applyChecked(this.checkedValue);
	}
}
